import React from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core/styles';
import MomentUtils from '@date-io/moment';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles } from '@material-ui/core';
import moment from 'moment';
import momentz from 'moment-timezone';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(() =>
  createStyles({
    iconColor: {
      color: '#e0e0e0',
    },
    toolbar: {
      backgroundColor: 'red',
      borderRadius: 10,
    },
    datePicker: {
      backgroundColor: 'black',
      padding: '11px',
      color: '#e0e0e0',
      border: '1px solid #e0e0e0',
      borderRadius: '5px',
      height: '5px',
      fontSize: '14px',
      position: 'relative',
      cursor: 'pointer',
    },
  })
);

const materialTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#7D96AD',
      },
    },
    MuiInput: {
      underline: {
        '&:after': {
          borderBottom: 'none',
        },
        '&:before': {
          borderBottom: 'none',
        },
      },
    },
    MuiPickersDay: {
      daySelected: {
        backgroundColor: '#13639c',
      },
    },
    MuiInputBase: {
      root: {
        borderRadius: 5,
      },
    },
  },
});

export const disabledDates = [
  '2022-Jan-17',
  '2022-Feb-21',
  '2022-Apr-15',
  '2022-May-30',
  '2022-Jun-20',
  '2022-Jul-04',
  '2022-Sep-05',
  '2022-Nov-24',
  '2022-Dec-26',
  '2023-Jan-02',
  '2023-Jan-16',
  '2023-Feb-20',
  '2023-Apr-07',
  '2023-May-29',
  '2023-Jun-19',
  '2023-Jul-04',
  '2024-Jul-04',
  '2023-Sep-04',
  '2023-Nov-23',
  '2023-Dec-25',
  '2024-Jan-01',
  '2024-Jan-15',
  '2024-Feb-19',
  '2024-Mar-29',
  '2024-May-27',
  '2024-Jun-19',
  '2024-Sep-02',
  '2024-Nov-28',
  '2024-Dec-25',
];

const Calender = ({ getDate, value, disabled, key, expiration }) => {
  const classes = useStyles();
  const { isMobile, accessLevel } = useSelector((state) => state.appReducer);

  const disableWeekends = (date) => {
    let day = moment(date);
    const dow = day.day();
    let endingTime = moment('9:30am', 'h:mma');
    let startingTime = moment('12:01am', 'h:mma');
    let nowTxt = momentz().tz('America/New_York').format('h:mma');
    let convertedText = moment(nowTxt, 'h:mma');
    switch (true) {
      case dow === 6:
        return true;

      case dow === 0:
        return true;

      case moment(convertedText).isBefore(endingTime) &&
        moment(convertedText).isAfter(startingTime) &&
        moment(date).isSame(new Date(), 'day'):
        return true;

      case disabledDates.includes(moment(date).format('YYYY-MMM-DD')):
        return true;

      default:
        return false;
    }
  };
  return (
    <div
      style={
        isMobile
          ? { maxWidth: '108px', minWidth: '108px' }
          : { maxWidth: '130px', minWidth: '128px' }
      }
    >
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <div style={{ position: 'relative' }}>
          <MuiThemeProvider theme={materialTheme}>
            <DatePicker
              style={{ borderRadius: 5 }}
              dialogprops={{ className: classes.toolbar }}
              minDate={
                new Date(new Date().getTime() - 105 * 24 * 60 * 60 * 1000)
              }
              disablePast={accessLevel === 'fullaccess' ? false : true}
              disableFuture={expiration ? false : true}
              maxDate={expiration}
              autoOk={true}
              shouldDisableDate={disableWeekends}
              variant="inline"
              disabled={key === 'undefined' ? false : disabled}
              inputProps={{ className: classes.datePicker }}
              invalidDateMessage=""
              format="YYYY-MM-DD"
              onChange={(e) => {
                const date = e.format('YYYY-MM-DD');
                getDate(date);
              }}
              value={value}
            />
          </MuiThemeProvider>
          <div
            style={
              isMobile
                ? {
                  position: 'absolute',
                  top: '2px',
                  right: '1px',
                }
                : { position: 'absolute', right: '8%', top: '2px' }
            }
          >
            <ArrowDropDownIcon className={classes.iconColor} />
          </div>
        </div>
      </MuiPickersUtilsProvider>
    </div>
  );
};

export default Calender;



// WEBPACK FOOTER //
// ./src/components/Calender.js